// Core lib dependencies.
import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

// Shared utils for Display Items.
import * as utils from '../utils.jsx';

// Model objects.
import DisplayItem from '../../../model/entity/DisplayItem/DisplayItem.js';
import itemFactory from '../../../../apps/UgcWall/components/ItemFactory';

/**
 * Media card Display Item.
 *
 * @namespace
 * @memberOf Common.Components.DisplayItems.Items
 */
class MediaCard extends React.Component {
  /**
   * Constructor.
   *
   * @param {object} props The injected props
   */
  constructor(props) {
    super(props);
  }

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Render methods */

  /**
   * Render the component. Compose child components as required.
   *
   * @return {ReactElement}
   */
  render() {
    const _profile = utils.getItemProfile({
        item:                this.props.item,
        onExternalLinkClick: this.props.onExternalLinkClick,
      }),
      _mainContent = utils.getItemContent({ item: this.props.item, type: 'main' }),
      _secondaryContent = utils.getItemContent({
        item:                this.props.item,
        type:                'secondary',
        onExternalLinkClick: this.props.onExternalLinkClick,
      }),
      _networkIcon = utils.getNetworkIcon(this.props.item.meta.network),
      _timestamp = utils.getItemTimestamp({
        item:                this.props.item,
        onExternalLinkClick: this.props.onExternalLinkClick,
      });

    const innerStyle = {};

    const displayItemModel = {
      className: utils.getClassNamesForItem({
        item:         this.props.item,
        templateOpts: this.props.templateOpts,
        itemOpts:     this.props.itemOpts,
        isOverlay:    this.props.isOverlay,
        tabIndex:     this.props.tabIndex,
      }),
      'data-ngx-tags': this.props.item.meta.tags,
      'data-ngx-id':   this.props.item.id,
      onClick:         () => {
        this.props.onClick(this.props.item);
      },
    };
    return (
      <div {...displayItemModel} ref={c => (this.card = c)} tabIndex={this.props.tabIndex}>
        <div className="xItemInner" style={innerStyle}>
          {_networkIcon}
          {this.props.networkActions}
          {this.props.sharingActions}
          {this.props.itemAsset}
          {_mainContent}
          {_secondaryContent}
          <If condition={!_.isEmpty(this.props.item.originalContent)}>
            <div className="xOriginalContainer">
              {itemFactory({
                item:                this.props.item.originalContent,
                itemOpts:            this.props.itemOpts,
                templateOpts:        this.props.templateOpts,
                moduleOpts:          this.props.moduleOpts,
                assetUrl:            this.props.assetUrl,
                assetUgcUrl:         this.props.assetUgcUrl,
                onExternalLinkClick: this.props.onExternalLinkClick,
                onClick:             _.noop,
                tabIndex:            -1, // disable quoted container from being focused
              })}
            </div>
          </If>
          {_timestamp}
          {_profile}
          {this.props.platformActions}
        </div>
      </div>
    );
  }
}

/**
 * React PropTypes.
 *
 * @type {Object}
 * @property {Common.Model.Entity.DisplayItem} item The DisplayItem object.
 */
MediaCard.propTypes = {
  item:                PropTypes.instanceOf(DisplayItem),
  itemAsset:           PropTypes.element,
  onExternalLinkClick: PropTypes.func,
  onClick:             PropTypes.func.isRequired,
  platformActions:     PropTypes.element,
  networkActions:      PropTypes.element,
  sharingActions:      PropTypes.element,
  tabIndex:            PropTypes.number,
};

/**
 * React default props.
 *
 * @type {Object}
 */
MediaCard.defaultProps = {
  item:                {},
  templateOpts:        {},
  itemOpts:            {},
  itemAsset:           null,
  tabIndex:            0,
  onExternalLinkClick: _.noop,
  platformActions:     null,
  networkActions:      null,
  sharingActions:      null,
};

export default MediaCard;
